import React from "react";
import EstimateShipping from "./estimateshipping";
import "./estimateshipping.scss";
import { IContainerProps } from "./estimateshippinginterface";

const EstimateShippingContainer = (props: IContainerProps) => {

    return (
        <EstimateShipping
            togglePopupClick={props?.togglePopupClick}
            estShipping={props?.estShipping}
            shippingCost={props?.shippingCost}
            cartsDetails={props?.cartsDetails}
            getItemSummaryDetailsWithoutLoading={props?.getItemSummaryDetailsWithoutLoading}
        />
    );
}

export default EstimateShippingContainer;
